import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { CancellationContainer } from "@/components/features/cancellation/ui/container";

import { useConfirmParams } from "./hooks";

export const CancellationPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="解約" url={generatePath(PATHS.CANCELLATION, { hotelID })}>
			<CancellationContainer hotelID={hotelID} />
		</PageMeta>
	);
};
